import model3 from "../assets/model3.jpeg"
import models from "../assets/models.jpeg"
import modelx from "../assets/modelx.jpeg"
import modely from "../assets/modely.jpeg"
import solarRoof from "../assets/solar_roof.jpeg"
import solarPanels from "../assets/solar_panels.jpeg"

export const datas = [
    {
        name : "Model 3",
        img : model3,
        dataAos : "fade-up",
        dataAosAnchorPlacement : "top-bottom",
        id:"model3"

    },
    {
        name : "Model S",
        img : models,
        dataAos : "fade-up",
        dataAosAnchorPlacement : "center-bottom",
        id:"models"
    },
    {
        name : "Model X",
        img : modelx,
        dataAos : "fade-up",
        dataAosAnchorPlacement : "bottom-bottom",
        id:"modelx"
    },
    {
        name : "Model Y",
        img : modely,
        dataAos : "fade-up",
        dataAosAnchorPlacement : "top-center",
        id:"modely"
    },
    {
        name : "Solar Roof",
        img : solarRoof,
        dataAos : "fade-up",
        dataAosAnchorPlacement : "center-center",
        id:"solarRoof"
    },
    {
        name : "Solar Panels",
        img : solarPanels,
        dataAos : "fade-up",
        dataAosAnchorPlacement : "bottom-bottom",
        id:"solarPanels"
    },
]